import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { FrontendType } from '@coin/shared/core/util-enums';
import { AuthGuard } from '@coin/shared/auth/feature';
import { LoadingModule } from '@coin/shared/core/data-access';
import { OrgChartsSocCompatibilityComponent } from './components/org-charts-compatibility.component';

const routes: Routes = [
  {
    path: 'orgcharts/orgchart',
    canActivate: [AuthGuard],
    data: {
      frontendType: FrontendType.cosmos
    },
    component: OrgChartsSocCompatibilityComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), LegacyComponentsModule, LoadingModule],
  declarations: [OrgChartsSocCompatibilityComponent]
})
export class SocRoutingCompatibilityModule {}
